import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { environment } from '@wo-environments';

@Injectable()
export class PageTitleResolver  {
  private readonly fallbackTitle = environment.appName;

  public constructor(
    private readonly translateService: TranslateService,
  ) {}

  public resolve({ data }: ActivatedRouteSnapshot): Observable<string> {
    return typeof data['title'] === 'string'
      ? this.translateService
        .get(data['title'])
        .pipe(map((value) => (typeof value === 'string' ? value : this.fallbackTitle)))
      : of(this.fallbackTitle);
  }
}

